import api from "../proxy/config";
import axios from "./axiosConfig";
import {
  getIndexStatus,
  getVendorIndexStatus,
  postRefreshIndex,
} from "./reindexService";

export { getIndexStatus, getVendorIndexStatus, postRefreshIndex };

const getHeaders = () => ({
    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
});

const handleBackendError = (error, defaultMsg) => {
    if (error.response?.status === 500 || (typeof error.response?.data === 'string' && error.response.data.includes("Internal Server Error"))) {
        throw new Error("Si è verificato un problema, riprova più tardi.");
    }
    const backendError = error.response?.data;
    const message = typeof backendError === 'string' 
        ? backendError 
        : (backendError?.message || backendError?.error || defaultMsg);
    throw new Error(message);
};

export const searchProducts = async (request) => {
    try {
        const response = await axios.post(api.ricercaCatalog, request, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante la ricerca dei prodotti");
    }
};

export const associateProducts = async (idProdotti, idNuovaCategoria, alberoCategorie) => {
    try {
        const response = await axios.post(api.associazioneCatalog, {
            idProdotti,
            idNuovaCategoria,
            alberoCategorie
        }, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante l'associazione delle categorie");
    }
};

export const updateProduct = async (request) => {
    try {
        const response = await axios.post(api.modificaCatalog, request, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante la modifica del prodotto");
    }
};

export const getCategories = async (nome) => {
    try {
        const response = await axios.post(api.ricercaCategorie, nome || "", {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nel recupero delle categorie");
    }
};

export const getProductStats = async (id, nome, startDate = null, endDate = null) => {
    try {
        const response = await axios.post(api.statsCatalog, { 
            catalogListId: id, 
            nome,
            startDate,
            endDate
        }, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nel recupero delle statistiche");
    }
};

export const getAllCategories = async () => {
    try {
        const response = await axios.post(api.allCategories, {}, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nel caricamento delle categorie");
    }
};

export const getAllVendors = async () => {
    try {
        const response = await axios.post(api.allVendors, {}, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nel caricamento dei vendor");
    }
};

// Invio massivo dell'email con le novita' del portale a tutti i vendor
export const getVendorEmailRecipients = async () => {
    const response = await axios.post(api.vendorEmailRecipients, {}, {
        headers: getHeaders(),
    });
    return response.data;
};

// emails vuoto = invio a tutti gli account vendor.
// Volutamente senza handleBackendError: il motivo del fallimento va mostrato all'admin
export const sendVendorPortalUpdateEmail = async (emails = []) => {
    const response = await axios.post(api.sendVendorPortalUpdateEmail, { emails }, {
        headers: getHeaders(),
    });
    return response.data;
};

export const getGlobalTraffic = async (resolution = "ultimo_anno", limit = null, startDate = null, endDate = null) => {
    try {
        const response = await axios.post(api.trafficStats, { resolution, limit, startDate, endDate }, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nel caricamento delle statistiche di traffico");
    }
};

export const getTopProducts = async (resolution = "ultimo_anno", categoryListId = null, vendorListId = null, limit = 10, startDate = null, endDate = null) => {
    try {
        const response = await axios.post(api.trafficStatsProducts, { 
            resolution, 
            categoryListId, 
            vendorListId, 
            limit,
            startDate,
            endDate
        }, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nel caricamento della classifica prodotti");
    }
};

export const getTopCategories = async (resolution = "ultimo_anno", vendorListId = null, limit = 10, startDate = null, endDate = null) => {
    try {
        const response = await axios.post(api.trafficStatsCategories, { 
            resolution, 
            vendorListId, 
            limit,
            startDate,
            endDate
        }, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nel caricamento della classifica categorie");
    }
};

export const getRegistrationStats = async (resolution = "ultimo_anno", limit = null, startDate = null, endDate = null) => {
    try {
        const response = await axios.post(api.trafficStatsRegistrations, { 
            resolution, 
            limit,
            startDate,
            endDate
        }, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nel caricamento delle statistiche di registrazione");
    }
};
 